import { graphql } from "@/lib/gql/__generated__";

export const GoogleFreeBookingLinksSettingsI18n = graphql(`
	query GoogleFreeBookingLinksSettingsI18n($hotelID: ID!, $langCode: LangCode!) {
		googleFreeBookingLinksSettingsI18n(hotelID: $hotelID, lang: $langCode) {
			id
			lang
			hotelID
			hotelName
			address {
				country
				addr1
				addr2
				addr3
				city
				province
				postalCode
			}
			createdAt
			updatedAt
		}
	}
`);
